import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { AddressEntryType } from 'constants/address';
import { stateName } from './constants';
export const initialState = {
  form: {
    firstName: '',
    lastName: '',
    birthdate: '',
    ssn: '',
    personalIdNumber: '',
    nationality: null
  },
  address: null,
  canChange: true,
  status: UiState.Idle,
  isSsnNumberRequired: false,
  isPersonalIdNumberRequired: false,
  isBalanceActivated: false,
  isNationalityRequired: false,
  agreementHint: ''
};

const getDefaultFormValuesRequest = draft => {
  draft.status = UiState.Pending;
};

const getDefaultFormValuesSuccess = (draft, action) => {
  const {
    form
  } = action.payload;
  draft.form = form;
};

const setAddress = (draft, action) => {
  const {
    address
  } = action.payload;
  draft.address = address;
};

const setCanChange = (draft, action) => {
  const {
    canChange
  } = action.payload;
  draft.canChange = canChange;
};

const setIsSsnNumberRequired = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.isSsnNumberRequired = status;
};

const setIsPersonalIdNumberRequired = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.isPersonalIdNumberRequired = status;
};

const setIsBalanceActivated = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.isBalanceActivated = status;
};

const setIsNationalityRequired = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.isNationalityRequired = status;
};

const setAgreementHint = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.agreementHint = status;
};

const setStatus = (draft, action) => {
  const {
    status
  } = action.payload;
  draft.status = status;
};

const prefillAddress = (draft, action) => {
  const {
    fullName
  } = action.payload;
  draft.address = {
    name: fullName,
    entryType: AddressEntryType.Billing,
    countryId: null,
    city: null,
    line1: null,
    line2: null,
    postalCode: null,
    state: null
  };
};

const activateBalanceSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getDefaultFormValuesRequest,
    getDefaultFormValuesSuccess,
    setAddress,
    setCanChange,
    setIsSsnNumberRequired,
    setIsPersonalIdNumberRequired,
    setIsBalanceActivated,
    setIsNationalityRequired,
    setAgreementHint,
    setStatus,
    prefillAddress
  }
});
export const {
  actions
} = activateBalanceSlice;
export const plug = {
  [stateName]: activateBalanceSlice.reducer
};
export default activateBalanceSlice.reducer;